import { FormEvent } from "react"
import { Head, Link, useForm, usePage } from "@inertiajs/react"
import { AuthShell } from "@/components/AuthShell"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"

import type { PageProps } from "@/types/inertia"

export default function Login() {
  const { props } = usePage<PageProps>()
  const form = useForm({ email: "", password: "" })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.post("/login")
  }

  const baseError = props.errors?.base

  return (
    <>
      <Head title="Log in">
        <meta name="description" content="Log in to FloorCore Measure." />
        <meta property="og:title" content="Log in" />
        <meta property="og:description" content="Log in to FloorCore Measure." />
      </Head>
      <AuthShell
        footer={<>Invite-only. No account? Ask an admin to invite you.</>}
      >
        <h2 className="auth-title text-center">Log in</h2>
        <p className="mt-1.5 text-center text-sm text-ink-muted">
          Welcome back. Pick up where you left off.
        </p>

        {props.flash?.notice && (
          <p className="mt-4 text-center text-sm text-accent-display">
            {props.flash.notice}
          </p>
        )}
        {baseError && (
          <p
            data-testid="auth-error"
            className="mt-4 text-center text-sm text-danger-display"
          >
            {baseError}
          </p>
        )}

        <form onSubmit={submit} className="mt-5 space-y-4">
          <div className="space-y-1.5">
            <label htmlFor="email">Email</label>
            <Input
              id="email"
              type="email"
              autoComplete="email"
              autoFocus
              required
              value={form.data.email}
              onChange={(e) => form.setData("email", e.target.value)}
            />
          </div>
          <div className="space-y-1.5">
            <div className="flex items-center justify-between">
              <label htmlFor="password">Password</label>
              <Link href="/passwords/new" className="text-xs">
                Forgot password?
              </Link>
            </div>
            <Input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={form.data.password}
              onChange={(e) => form.setData("password", e.target.value)}
            />
          </div>
          <Button type="submit" className="w-full" disabled={form.processing}>
            Log in
          </Button>
        </form>
      </AuthShell>
    </>
  )
}
